module.exports = __webpack_public_path__ + "img/Patent_8.a9c3175a.jpg";